import React, { useEffect, useRef, useMemo } from 'react';
import DeductionTabs from '../../components/deduction-tabs.component';
import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { StatCard } from '../../components/dashboard/stat-card.component';
import { DashboardButton } from '../../components/dashboard/dashboard-button.component';
import { useTranslation } from 'react-i18next';
import { InvoiceTableDetailed } from '../../components/dashboard/invoice-table-detailed.component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';

const PlusIcon: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        viewBox="0 0 15 15"
        fill="none"
    >
        <path
            d="M7.41667 4.75V7.41667M7.41667 7.41667V10.0833M7.41667 7.41667H10.0833M7.41667 7.41667H4.75M14.0833 7.41667C14.0833 11.0986 11.0986 14.0833 7.41667 14.0833C3.73477 14.0833 0.75 11.0986 0.75 7.41667C0.75 3.73477 3.73477 0.75 7.41667 0.75C11.0986 0.75 14.0833 3.73477 14.0833 7.41667Z"
            stroke="#544196"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)

function ManageInvoicePage() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    let lang = searchParams.get("lang");
    function handleInvoice() {
        lang?.includes('en-us') ? navigate('/v2/create-invoice?lang=en-us') : navigate('/v2/create-invoice?lang=sv-se')
    }

    // Tab logic
    const [activeTab, setActiveTab] = useState('manage');
    const tabs = [
        { key: 'manage', label: t('MANAGE_INVOICES') },
        { key: 'credit', label: t('CREDIT_INVOICES') },
    ];
    // Lazy load credit invoice grid
    const CreditInvoiceTableDetailed = React.lazy(() => import('../../components/dashboard/credit-invoice-table-detailed.component'));

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='all-invoices'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}
                <div className="dashboard-main-content">
                    <Header setIsSidebarOpen={setIsSidebarOpen} />
                    <div className='px-3'>
                        <div>
                            <h1 className="dashboard-page__title mb-0">{t('MANAGE_INVOICES')}</h1>
                        </div>
                        <div className='pb-4'>
                            <StatCard
                                title={t('TOTAL_RECEIVABLES')}
                                className="receivables-card"
                            >
                                <DashboardButton
                                    onClick={handleInvoice}
                                    variant="primary"
                                    icon={<PlusIcon />}
                                >
                                    {t('CREATE_INVOICE')}
                                </DashboardButton>
                            </StatCard>
                        </div>
                        <div className="invoice-tabs-section mb-4">
                            <DeductionTabs
                                tabs={tabs}
                                activeTab={activeTab}
                                onTabChange={setActiveTab}
                            />
                        </div>
                        <div>
                            {activeTab === 'manage' && (
                                <InvoiceTableDetailed className="invoices-section" />
                            )}
                            {activeTab === 'credit' && (
                                <React.Suspense fallback={<div>Loading...</div>}>
                                    <CreditInvoiceTableDetailed className="invoices-section" />
                                </React.Suspense>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManageInvoicePage;
